'use es6';

import { createContext } from 'react';
const UsageTrackerContext = /*#__PURE__*/createContext({});
export default UsageTrackerContext;